/**
 * Transform-Objekt von dnd-kit, so weit beschrieben wie es fürs Rendern nötig ist —
 * damit die Bausteine hier nicht am dnd-kit-Typ hängen.
 */
export type DndTransformLike = {
  x: number;
  y: number;
  scaleX?: number;
  scaleY?: number;
};

/**
 * Übersetzt das dnd-kit-Transform in einen CSS-transform-Wert. Bewusst inline statt
 * `CSS.Transform.toString` aus `@dnd-kit/utilities` — der Import dort führt zu
 * Initialisierungsreihenfolge-Problemen.
 */
export function dndTransformToCss(transform: DndTransformLike | null | undefined): string | undefined {
  if (!transform) return undefined;
  const { x = 0, y = 0, scaleX = 1, scaleY = 1 } = transform;
  return `translate3d(${x}px, ${y}px, 0) scaleX(${scaleX}) scaleY(${scaleY})`;
}
